import { combineEpics } from "redux-observable";
import * as AdminEpic from "./admin.epic";
import * as DashboardEpic from "./dashboard.epic";
import * as DataEpic from "./data.epic";
import * as LoginEpic from "./login.epic";
import * as UserEpic from "./user.epic";
import * as UserGroupEpic from "./usergroup.epic";
import * as SummaryDataEpic from "./summaryData.epic";
import * as TemplateEpic from "./template.epic";

export const rootEpic = combineEpics(
    DashboardEpic.createPlot,
    DashboardEpic.createPlotSuccess,
    DashboardEpic.deletePlotEvent,
    DashboardEpic.error,
    DashboardEpic.flagPlot,
    DashboardEpic.getEventQuestions,
    DashboardEpic.getQuestionReferenceData,
    DashboardEpic.getReferenceData,
    DashboardEpic.report,
    DashboardEpic.save,
    DashboardEpic.submitSurvey,
    DashboardEpic.updatePlot,
    DashboardEpic.uploadFiles,
    DashboardEpic.uploadPlotPhotos,
    DashboardEpic.deleteFile,

    AdminEpic.addMemberToUserGroup,
    AdminEpic.approveMemberforUserGroup,
    AdminEpic.batchImport,
    AdminEpic.deleteMemberFromUserGroup,
    AdminEpic.editUser,
    AdminEpic.editUserGroup,
    AdminEpic.getSingleUser,
    AdminEpic.getPlotMetaInfo,
    AdminEpic.searchUsers,
    AdminEpic.searchUserGroups,
    AdminEpic.searchPlots,
    AdminEpic.searchFiles,
    AdminEpic.searchUserRoles,
    AdminEpic.updateAdminMemberForUserGroup,

    UserEpic.getCurrentUser,
    UserEpic.registerUser,
    UserEpic.sendPasswordReset,
    UserEpic.changePassword,
    UserEpic.changePasswordFromToken,
    UserEpic.sendActivateAccount,
    UserEpic.activeAccount,
    UserEpic.updateUser,
    UserEpic.updateUserPreferences,
    UserEpic.assignUserRole,
    UserEpic.unassignUserRole,
    UserEpic.changeUserOptOutStatus,
    //UserEpic.getCurrentUserSuccess,

    UserGroupEpic.getUserGroup,
    
    LoginEpic.login,
    LoginEpic.loginWithToken,
    LoginEpic.logout,

    DataEpic.getPlotEvents,
    DataEpic.getPlotSeasonSummaryData,
    DataEpic.getPlotSummaryData,
    DataEpic.getPlots,
    DataEpic.getSinglePlot,
    DataEpic.getSummaryData,
    DataEpic.getUserPlots,
    DataEpic.getUserPlotEventSummaryData,
    DataEpic.search,
    
    SummaryDataEpic.getSurveyResults,
    SummaryDataEpic.getPlotEventsCount,
    SummaryDataEpic.getMetadata,

    TemplateEpic.searchTemplates
);